/**
 * Canonical wardrobe envelopes (batch-003 `wardrobe/recipes/wardrobe.json`, copied exactly) and the static
 * resources they consume. Constants, not a JSON import, so any bundler works.
 */
import { HUSH_BOAT_PIP_CLUE, HUSH_RIBBON_REST } from '../../../shared/assets/hushStatic';
import type { WardrobeRecipe, WardrobeResources } from './types';

export const HUSH_WARDROBE_PIP: WardrobeRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.wardrobe.pip.v1',
  assetId: 'npc.pip_reedwhistle.appearance',
  generatorId: 'hush.ghost_wardrobe.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  detail: 'standard',
  params: { look: 'pip', pose: 'idle', propSupport: 'rig-if-available-else-nearby', facePolicy: 'preserve-existing-rig-face' },
};

export const HUSH_WARDROBE_MALLOW: WardrobeRecipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.wardrobe.mallow.v1',
  assetId: 'npc.mallow_wick.appearance',
  generatorId: 'hush.ghost_wardrobe.v1',
  seed: 20067018,
  paletteId: 'nook_warm',
  detail: 'standard',
  params: { look: 'mallow', pose: 'idle', propSupport: 'rig-if-available-else-nearby', facePolicy: 'preserve-existing-rig-face' },
};

/** Batch-003 `recipes/static-resources.json`: the canonical rest ribbon and Pip's clue boat. */
export const HUSH_WARDROBE_RESOURCES: WardrobeResources = { ribbon: HUSH_RIBBON_REST, boat: HUSH_BOAT_PIP_CLUE };
